export default __webpack_public_path__ + "static/media/fleche_noir.53cd7078.svg";